import length from "rfuncs/functions/length"

import type { FileData } from "../types/FileData"

export default (filename: string): Omit<FileData, "meta"> => {
  const folders = filename.split("/")
  const parts = folders.pop()!.split(".")
  const ext = length(parts) > 1 ? parts.pop()! : ""

  return {
    basename: parts.join("."),
    ext,
    folder: folders.join("/") + "/",
  }
}
